"use strict";module.exports = {
  onInput: function onInput(input) {
    this.state = {
      open: input.open || false };

  },

  setOpen: function setOpen(isOpen) {
    if (this.input.variant === 'modal') {
      this.state.open = isOpen;
    }
  },

  handleExpand: function handleExpand() {
    this.setOpen(true);
    this.emit('expand');
  },

  handleOverlayClose: function handleOverlayClose() {
    this.getComponent('base').collapse();
  },

  isExpanded: function isExpanded() {
    return this.getComponent('base').isExpanded();
  },

  expand: function expand() {
    this.getComponent('base').expand();
  },

  collapse: function collapse() {
    this.getComponent('base').collapse();
  },

  handleCollapse: function handleCollapse() {
    this.setOpen(false);

    this.getEl('host').focus();
    this.emit('collapse');
  } };